import React, { FC } from "react";
import HtmlRenderer from "./HtmlRenderer";

interface VacAndCheckUpsProps {
  isOpen: any;
  onClose: any;
  content: any;
  heading: any;
}

const VacCheckUps: FC<VacAndCheckUpsProps> = ({ isOpen, onClose, content, heading }) => {
  const tableData = content?.tableDetails || content;

  return <HtmlRenderer isOpen={isOpen} onClose={onClose} heading={heading} content={tableData} />;
};

export default VacCheckUps;
